// extracted by mini-css-extract-plugin
module.exports = {"wrap":"yd-z","subtitle":"zd-z","contentWrap":"Ad-z","imgWrap":"Bd-z","heading":"Cd-z","copy":"Dd-z"};